"use client";


const ErrorPage = () => {
  return (
    <></>
  );
};

export default ErrorPage;
